var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroCurtain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1974.96 759.632H1619.7L687.678 2389.11H1042.25L1974.96 759.632Z",
    fill: "url(#paint0_linear_2059_4947)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1959.19 604.676L1606.72 649.203L886.278 2382.64L1238.06 2338.2L1959.19 604.676Z",
    fill: "url(#paint1_linear_2059_4947)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1924.11 452.922L1580.01 541.273L1082.5 2351.34L1425.94 2263.16L1924.11 452.922Z",
    fill: "url(#paint2_linear_2059_4947)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1870.29 306.759L1539.98 437.541L1273.25 2295.69L1602.93 2165.16L1870.29 306.759Z",
    fill: "url(#paint3_linear_2059_4947)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.58 168.494L1487.25 339.645L1455.52 2216.57L1766.24 2045.75L1798.58 168.494Z",
    fill: "url(#paint4_linear_2059_4947)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1710.1 40.3067L1422.68 249.127L1626.44 2115.23L1913.3 1906.82L1710.1 40.3067Z",
    fill: "url(#paint5_linear_2059_4947)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.25 -75.7798L1347.27 167.417L1783.31 1993.27L2041.79 1750.54L1606.25 -75.7798Z",
    fill: "url(#paint6_linear_2059_4947)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.68 -177.935L1262.22 95.803L1923.66 1852.6L2149.68 1579.4L1488.68 -177.935Z",
    fill: "url(#paint7_linear_2059_4947)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.22 -264.549L1168.86 35.412L2045.27 1695.46L2235.26 1396.08L1359.22 -264.549Z",
    fill: "url(#paint8_linear_2059_4947)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.93 -334.255L1068.67 -12.8004L2146.23 1524.31L2297.2 1203.49L1219.93 -334.255Z",
    fill: "url(#paint9_linear_2059_4947)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.01 -385.954L963.225 -48.0757L2224.94 1341.86L2334.51 1004.65L1073.01 -385.954Z",
    fill: "url(#paint10_linear_2059_4947)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M920.76 -418.831L854.19 -69.8569L2280.16 1150.99L2346.6 802.696L920.76 -418.831Z",
    fill: "url(#paint11_linear_2059_4947)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M765.589 -432.367L743.282 -77.8015L2311.02 954.696L2333.29 600.822L765.589 -432.367Z",
    fill: "url(#paint12_linear_2059_4947)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M609.954 -426.348L632.261 -71.7829L2317.04 756.083L2294.78 402.209L609.954 -426.348Z",
    fill: "url(#paint13_linear_2059_4947)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M456.296 -400.871L522.867 -51.8971L2298.12 558.281L2231.68 209.989L456.296 -400.871Z",
    fill: "url(#paint14_linear_2059_4947)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.042 -356.335L416.826 -18.4564L2254.56 364.412L2144.99 27.1927L307.042 -356.335Z",
    fill: "url(#paint15_linear_2059_4947)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.544 -293.444L315.81 28.0108L2187.04 177.531L2036.07 -143.297L164.544 -293.444Z",
    fill: "url(#paint16_linear_2059_4947)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0535 -213.19L221.415 86.7717L2096.63 0.585159L1906.64 -298.791L31.0535 -213.19Z",
    fill: "url(#paint17_linear_2059_4947)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-91.325 -116.837L135.13 156.9L1984.76 -163.634L1758.74 -436.837L-91.325 -116.837Z",
    fill: "url(#paint18_linear_2059_4947)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-200.659 -5.90685L58.3187 237.29L1853.19 -312.536L1594.71 -555.258L-200.659 -5.90685Z",
    fill: "url(#paint19_linear_2059_4947)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-295.23 117.852L-7.81341 326.673L1703.99 -443.774L1417.13 -652.187L-295.23 117.852Z",
    fill: "url(#paint20_linear_2059_4947)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-373.543 252.489L-62.2202 423.64L1539.52 -555.278L1228.81 -726.094L-373.543 252.489Z",
    fill: "url(#paint21_linear_2059_4947)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-434.368 395.879L-104.049 526.662L1362.37 -645.288L1032.7 -775.815L-434.368 395.879Z",
    fill: "url(#paint22_linear_2059_4947)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-476.737 545.762L-132.632 634.113L1175.34 -712.387L831.908 -800.566L-476.737 545.762Z",
    fill: "url(#paint23_linear_2059_4947)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-499.994 699.773L-147.529 744.3L981.37 -755.515L629.593 -799.955L-499.994 699.773Z",
    fill: "url(#paint24_linear_2059_4947)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-503.758 855.483H-148.491L783.529 -773.994H428.956L-503.758 855.483Z",
    fill: "url(#paint25_linear_2059_4947)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-487.976 1010.44L-135.511 965.912L584.933 -767.53L233.155 -723.09L-487.976 1010.44Z",
    fill: "url(#paint26_linear_2059_4947)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-452.901 1162.19L-108.796 1073.84L388.709 -736.225L45.2755 -648.046L-452.901 1162.19Z",
    fill: "url(#paint27_linear_2059_4947)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-399.086 1308.36L-68.768 1177.58L197.952 -680.574L-131.721 -550.046L-399.086 1308.36Z",
    fill: "url(#paint28_linear_2059_4947)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-238.888 1574.81L48.5284 1365.99L-155.234 -500.114L-442.089 -291.701L-238.888 1574.81Z",
    fill: "url(#paint29_linear_2059_4947)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-135.046 1690.9L123.932 1447.7L-312.108 -378.151L-570.581 -135.429L-135.046 1690.9Z",
    fill: "url(#paint30_linear_2059_4947)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.4656 1793.05L208.99 1519.31L-452.452 -237.488L-678.465 35.715L-17.4656 1793.05Z",
    fill: "url(#paint31_linear_2059_4947)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.983 1879.66L302.345 1579.7L-574.067 -80.3449L-764.057 219.031L111.983 1879.66Z",
    fill: "url(#paint32_linear_2059_4947)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M251.277 1949.37L402.542 1627.92L-675.018 90.8019L-825.988 411.629L251.277 1949.37Z",
    fill: "url(#paint33_linear_2059_4947)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M398.203 2001.07L507.986 1663.19L-753.729 273.252L-863.298 610.471L398.203 2001.07Z",
    fill: "url(#paint34_linear_2059_4947)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M550.447 2033.95L617.017 1684.97L-808.954 464.129L-875.395 812.421L550.447 2033.95Z",
    fill: "url(#paint35_linear_2059_4947)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M705.612 2047.48L727.919 1692.92L-839.82 660.421L-862.084 1014.29L705.612 2047.48Z",
    fill: "url(#paint36_linear_2059_4947)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M861.255 2041.46L838.948 1686.9L-845.836 859.034L-823.572 1212.91L861.255 2041.46Z",
    fill: "url(#paint37_linear_2059_4947)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.91 2015.99L948.344 1667.01L-826.913 1056.83L-760.473 1405.13L1014.91 2015.99Z",
    fill: "url(#paint38_linear_2059_4947)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.16 1971.45L1054.38 1633.57L-783.354 1250.7L-673.785 1587.92L1164.16 1971.45Z",
    fill: "url(#paint39_linear_2059_4947)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.66 1908.56L1155.4 1587.1L-715.83 1437.58L-564.861 1758.41L1306.66 1908.56Z",
    fill: "url(#paint40_linear_2059_4947)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.15 1828.31L1249.79 1528.34L-625.422 1614.53L-435.433 1913.91L1440.15 1828.31Z",
    fill: "url(#paint41_linear_2059_4947)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.53 1731.95L1336.07 1458.22L-513.551 1778.75L-287.538 2051.95L1562.53 1731.95Z",
    fill: "url(#paint42_linear_2059_4947)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1671.86 1621.02L1412.89 1377.83L-381.981 1927.65L-123.509 2170.37L1671.86 1621.02Z",
    fill: "url(#paint43_linear_2059_4947)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1766.44 1497.26L1479.02 1288.44L-232.781 2058.89L54.075 2267.3L1766.44 1497.26Z",
    fill: "url(#paint44_linear_2059_4947)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.75 1362.63L1533.43 1191.48L-68.3152 2170.39L242.399 2341.21L1844.75 1362.63Z",
    fill: "url(#paint45_linear_2059_4947)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1905.58 1219.24L1575.26 1088.45L108.837 2260.4L438.511 2390.93L1905.58 1219.24Z",
    fill: "url(#paint46_linear_2059_4947)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1947.94 1069.35L1603.84 981.003L295.865 2327.5L639.299 2415.68L1947.94 1069.35Z",
    fill: "url(#paint47_linear_2059_4947)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1971.19 915.343L1618.73 870.816L489.831 2370.63L841.608 2415.07L1971.19 915.343Z",
    fill: "url(#paint48_linear_2059_4947)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2059_4947",
    x1: 1504.33,
    y1: 983.446,
    x2: 1815.85,
    y2: 1166.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2059_4947",
    x1: 1520.32,
    y1: 885.711,
    x2: 1852.32,
    y2: 1028.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2059_4947",
    x1: 1523.93,
    y1: 786.745,
    x2: 1871.19,
    y2: 886.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2059_4947",
    x1: 1515.1,
    y1: 688.106,
    x2: 1872.14,
    y2: 743.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2059_4947",
    x1: 1493.98,
    y1: 591.351,
    x2: 1855.16,
    y2: 601.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2059_4947",
    x1: 1460.9,
    y1: 498.006,
    x2: 1820.54,
    y2: 463.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2059_4947",
    x1: 1416.39,
    y1: 409.543,
    x2: 1768.8,
    y2: 329.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2059_4947",
    x1: 1361.14,
    y1: 327.357,
    x2: 1700.77,
    y2: 204.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2059_4947",
    x1: 1296.02,
    y1: 252.743,
    x2: 1617.51,
    y2: 87.8173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2059_4947",
    x1: 1222.06,
    y1: 186.88,
    x2: 1520.35,
    y2: -17.0394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2059_4947",
    x1: 1140.43,
    y1: 130.805,
    x2: 1410.81,
    y2: -108.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2059_4947",
    x1: 1052.42,
    y1: 85.4029,
    x2: 1290.63,
    y2: -186.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2059_4947",
    x1: 959.41,
    y1: 51.3891,
    x2: 1161.69,
    y2: -248.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2059_4947",
    x1: 862.877,
    y1: 29.3009,
    x2: 1026.03,
    y2: -293.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2059_4947",
    x1: 764.333,
    y1: 19.4858,
    x2: 885.794,
    y2: -320.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2059_4947",
    x1: 665.335,
    y1: 22.0999,
    x2: 743.187,
    y2: -330.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2059_4947",
    x1: 567.442,
    y1: 37.1008,
    x2: 600.457,
    y2: -322.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2059_4947",
    x1: 472.202,
    y1: 64.2522,
    x2: 459.86,
    y2: -296.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2059_4947",
    x1: 381.118,
    y1: 103.126,
    x2: 323.612,
    y2: -253.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2059_4947",
    x1: 295.627,
    y1: 153.109,
    x2: 193.865,
    y2: -193.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2059_4947",
    x1: 217.073,
    y1: 213.413,
    x2: 72.6596,
    y2: -117.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2059_4947",
    x1: 146.698,
    y1: 283.088,
    x2: -38.0894,
    y2: -27.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2059_4947",
    x1: 85.6055,
    y1: 361.034,
    x2: -136.641,
    y2: 76.1362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2059_4947",
    x1: 34.7686,
    y1: 446.021,
    x2: -221.433,
    y2: 191.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2059_4947",
    x1: -5.02227,
    y1: 536.71,
    x2: -291.138,
    y2: 316.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2059_4947",
    x1: -33.1264,
    y1: 631.67,
    x2: -344.644,
    y2: 448.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2059_4947",
    x1: -49.1072,
    y1: 729.404,
    x2: -381.114,
    y2: 586.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2059_4947",
    x1: -52.7157,
    y1: 828.371,
    x2: -399.976,
    y2: 728.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2059_4947",
    x1: -43.8957,
    y1: 927.01,
    x2: -400.932,
    y2: 871.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2059_4947",
    x1: 10.3062,
    y1: 1117.11,
    x2: -349.326,
    y2: 1152.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2059_4947",
    x1: 54.8185,
    y1: 1205.57,
    x2: -297.593,
    y2: 1285.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2059_4947",
    x1: 110.075,
    y1: 1287.76,
    x2: -229.557,
    y2: 1411.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2059_4947",
    x1: 175.188,
    y1: 1362.37,
    x2: -146.308,
    y2: 1527.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2059_4947",
    x1: 249.149,
    y1: 1428.24,
    x2: -49.141,
    y2: 1632.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2059_4947",
    x1: 330.776,
    y1: 1484.31,
    x2: 60.3959,
    y2: 1724.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2059_4947",
    x1: 418.785,
    y1: 1529.71,
    x2: 180.579,
    y2: 1801.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2059_4947",
    x1: 511.791,
    y1: 1563.73,
    x2: 309.516,
    y2: 1863.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2059_4947",
    x1: 608.332,
    y1: 1585.82,
    x2: 445.177,
    y2: 1908.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2059_4947",
    x1: 706.878,
    y1: 1595.63,
    x2: 585.417,
    y2: 1935.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2059_4947",
    x1: 805.872,
    y1: 1593.02,
    x2: 728.02,
    y2: 1945.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2059_4947",
    x1: 903.767,
    y1: 1578.01,
    x2: 870.752,
    y2: 1937.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2059_4947",
    x1: 999.005,
    y1: 1550.86,
    x2: 1011.35,
    y2: 1911.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2059_4947",
    x1: 1090.09,
    y1: 1511.99,
    x2: 1147.59,
    y2: 1868.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2059_4947",
    x1: 1175.58,
    y1: 1462.01,
    x2: 1277.34,
    y2: 1808.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2059_4947",
    x1: 1254.14,
    y1: 1401.7,
    x2: 1398.55,
    y2: 1732.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2059_4947",
    x1: 1324.51,
    y1: 1332.03,
    x2: 1509.3,
    y2: 1642.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2059_4947",
    x1: 1385.6,
    y1: 1254.08,
    x2: 1607.85,
    y2: 1538.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2059_4947",
    x1: 1436.44,
    y1: 1169.09,
    x2: 1692.64,
    y2: 1423.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2059_4947",
    x1: 1476.22,
    y1: 1078.41,
    x2: 1762.34,
    y2: 1299.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCurtain);
export default __webpack_public_path__ + "static/media/heroCurtain.dad5a49468f1a3d2fdbb050cb14dca9a.svg";
export { ForwardRef as ReactComponent };